module.exports = __webpack_public_path__ + "static/media/ejs.2bb65b54.svg";